<template>
	<div class="card categorias">
		<div class="card-header">
			<svg width="1em" height="1em" viewBox="0 0 11 24">
				<polygon points="0,0 11,12 0,24 6,12" fill="currentcolor"/>
			</svg>
			{{title}}
		</div>
		<ul class="list-categories collapse">
			
			<li v-for="categoria in categorias">
				<slot></slot>
				<a :href="categoria.link">{{categoria.name}}</a>
			</li>

		</ul>
	</div>
</template>

<script>
export default{
	name: 'Categorias',
	props: [
		'title',
		'categorias'
	]
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/Sidebar/Categorias.vue